import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;
export class userSection_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
                <!-- ko if: user() -->   
                    <div class="w-sidebar-user icon" data-bind="click: onclickViewProfile, style: { cursor: isUserLinkDisabled() ? 'auto' : 'pointer'}, css: { 'i-go-to': !isUserLinkDisabled() }">
                        <div class="w-user-img">
                            <img class="user-img" data-bind="attr:{src: profilePicture}" alt="">
                        </div>
    
                        <div class="w-user-info">
                            <strong>
                                <span data-bind="text: user().user.valnet_user.fullNameAndLogin"></span>
                            </strong>
                            <p data-bind="text: user().user.valnet_user.roles[0].name"></p>
                        </div>
                    </div> 
                    <ul data-bind="foreach: brands, attr: {'class': (brands().length > 10) ? 'brand-list is-smaller' : 'brand-list'}" class="brand-list ">
                    
                        <li data-bind="event: { click: $parent.onClickBrandIcon }, attr: {'class': (id == $parent.selectedBrandId()) ? 'is-selected brand-item': 'brand-item'}, css: iconImage">
                            <a data-bind="attr: { href :  '/brand/' + id + '/articles/', title: name}"></a>
                        </li>
                    </ul>
                <!-- /ko -->
                `;
    }

    protected getTemplateName(): string{
        return "userSection-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["user-section"];
    }

    protected buildViewModel(): any{
        let self = this;
        return {
            user: ko.observable(null),
            profilePicture: ko.observable("/assets/images/default-user.png"),
            isUserLinkDisabled: ko.observable(false),
            selectedBrandId: ko.observable(0),
            brands: ko.observableArray([]),
            origin: document.location.origin,
            onclickViewProfile: (data) => {
                self.onClickViewProfile(data.user().user.id);
            },
            onClickBrandIcon: (data) => {
                self.onClickBrandIcon(data);
            }
        };
    }

    public setUser(user: any){

        if(user.user.valnet_user.pictureUrl){
            this.getTemplateViewModel().profilePicture(user.user.valnet_user.pictureUrl);
        }

        this.getTemplateViewModel().selectedBrandId(this.caller.getGlobalBrandId());
        this.getTemplateViewModel().user(user);
    }

    public setBrands(brands) {

        this.getTemplateViewModel().brands(brands);
    }

    public onClickViewProfile(idUser){

        let isUserLinkDisabled = this.getTemplateViewModel().isUserLinkDisabled();

        if(!isUserLinkDisabled){
            this.caller.viewProfile(idUser);
        }
    }
    public onClickBrandIcon(data){

        this.getTemplateViewModel().selectedBrandId(data.id);

        this.caller.resetActiveMenus();
        this.caller.changeSelection(data.id);
    }
    public setIsUserLinkDisabled(isUserLinkDisabled: boolean){

        this.getTemplateViewModel().isUserLinkDisabled(isUserLinkDisabled);
    }

    public setSelectedBrandId(brandId: number): void {

        this.getTemplateViewModel().selectedBrandId(brandId);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/userSection_template.ts